import React, { useMemo, useState } from 'react'
import { cn, Text } from '@artprov/design-system'
import { LoaderContext } from './use-loader.hook.jsx'
import './Loader.css'

export function LoaderProvider({ children }) {
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState('Se está procesando tu solicitud')
  const [description, setDescription] = useState(null)

  const obj = useMemo(
    () => ({
      show: ({ message = null, description = null }) => {
        setMessage(message || 'Se está procesando tu solicitud')
        setDescription(description)
        setOpen(true)
      },
      hide: () => {
        setOpen(false)
        setDescription(null)
      },
    }),
    []
  )

  return (
    <LoaderContext.Provider value={obj}>
      {children}
      {open && (
        <div className="loader-overlay">
          <div className="loader-container">
            <div className="loader-spinner"></div>
            <p className={cn('loader-message')}>{message}</p>
            {description && (
              <Text variant="body2" className="text-tertiary-20 mb-2">
                {description}
              </Text>
            )}
          </div>
        </div>
      )}
    </LoaderContext.Provider>
  )
}
